import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { TableCell, TableRow } from '@mui/material';
import { fonts } from '@theme/fontsCustomer';
import type { TenantSsoProviderModel } from '@repositories/tenantSsoProviderRepository/models/TenantSsoProviderModel';
import { StatusBadge } from './SsoProviderStyles';

type Props = {
  provider: TenantSsoProviderModel;
};

export const SsoProviderTableRow = ({ provider }: Props) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(provider.id);
  };

  return (
    <StyledTableRow onClick={handleRowClick}>
      <StyledTableCell>{provider.providerName}</StyledTableCell>
      <StyledTableCell>{provider.registrationId}</StyledTableCell>
      <IssuerUriCell>{provider.issuerUri}</IssuerUriCell>
      <StyledTableCell>
        <StatusBadge className={provider.statusColor}>{provider.statusLabel}</StatusBadge>
      </StyledTableCell>
      <StyledTableCell>{provider.createdDate || '-'}</StyledTableCell>
    </StyledTableRow>
  );
};

const StyledTableRow = styled(TableRow)`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme: { colors } }) => colors['bg-gray-lighter']};
  }
`;

const StyledTableCell = styled(TableCell)`
  ${fonts.Body2};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
`;

const IssuerUriCell = styled(StyledTableCell)`
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
